import { CommonModule, DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { OrganizationComponent } from '../organization/organization.component';
import { UserassignComponent } from '../userassign/userassign.component';
import { FormBuilder } from '@angular/forms';
import { DataService } from '../expense/receipt/data.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { HeadlineService } from '../common/services/headline.service';
import { LoadingService } from '../common/services/loading.service';
import { SharedValidationService } from '../common/shared-validation.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SecurePipe } from '../pipes/secure.pipe';
import { Subscription } from 'rxjs';
import { receiptData } from '../expense/receipt/receipt.component';
import { environment } from 'src/environments/environment';
import { AssignbillComponent } from '../assignbill/assignbill.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import Chart from 'chart.js/auto';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { ExportService } from '../common/services/exportBill.service';
import { MatSelectModule } from '@angular/material/select';
import { ExportComponentComponent } from '../export-component/export-component.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-assign-biils-trip',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatIconModule,
    MatSelectModule,
    MatSortModule,
    MatPaginatorModule,
    MatCardModule,
    MatTableModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    SecurePipe,
    MatTooltipModule,
  ],
  templateUrl: './assign-biils-trip.component.html',
  styleUrls: ['./assign-biils-trip.component.css'],
})
export class AssignBiilsTripComponent {
  tripId: string;
  billStatus: string;
  selectedTab = 'details';
  orgId: string = '';
  selectedTabIndex: number = 0;
  headers = [
    'Bill Name',
    'Created By',
    'Trip Name',
    'Category',
    'Date On Bill',
    'Time On Bill',
    'Amount',
    'Organization',
    'Status',
    'Phone',
  ];
  title = 'Bill Details';
  private subscriptions: Subscription[] = [];
  imageLoaded: { [key: string]: boolean } = {};
  displayedColumns: string[] = [
    'CreatedBy',
    'name',
    'type',
    'amount',
    'Status',
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  showTable = false;
  loading = false;
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort: MatSort | undefined;

  constructor(
    private ds: DataService,
    private router: Router,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private exportService: ExportService,
    private route: ActivatedRoute,
    private headlineService: HeadlineService,
    private ngxService: NgxSpinnerService,
    private snackBar: MatSnackBar
  ) {
    this.tripId = this.route.snapshot.params['tripId'];
    this.route.queryParams.subscribe((params) => {
      this.orgId = params['org_id'];
    });
  }

  async ngOnInit(): Promise<void> {
    if (this.isLoggedIn()) {
      console.debug('this.dataSource.data', this.dataSource.data);
      console.debug(this.orgId);
      if (this.isLoggedIn()) {
        await this.loadData();
        if (this.dataSource.data.length === 0) {
          this.openBillAdd();
        } else {
          this.dialog.closeAll();
        }
      } else {
        this.snackBar.open('Please Log In ', 'OK', {
          duration: 2000,
        });
        this.router.navigate(['/login']);
      }
      console.debug(this.dataSource.data);
      console.debug('this.dataSource.data@@', this.dataSource.data);
    } else {
      this.snackBar.open('Please debug in first ', 'OK', {
        duration: 2000,
      });
      this.router.navigate(['/']);
    }
  }

  switchTab(event: MatTabChangeEvent): void {
    this.selectedTab = event.tab.textLabel.toLowerCase();
    this.loadDataForTab(this.selectedTab);
  }

  async loadDataForTab(tab: string): Promise<void> {
    if (tab === 'chart') {
      const dataForPieChart = this.getDataForPieChart(this.dataSource.data);
      this.generatePieChart(dataForPieChart);
    }
  }

  getDataForPieChart(items: any): any[] {
    const statuses = [
      'Paid',
      'Approved',
      'Rejected',
      'Pending',
      'Updated',
      'In-Progress',
      'Review',
    ];
    const dataForPieChart = statuses.map((status) => {
      console.debug('this.data', this.dataSource.data);
      const totalAmount = items
        .filter(
          (element) =>
            this.getLatestStatus(element) === status &&
            !isNaN(Number(element.amount_info.value))
        )
        .map((element) => Number(element.amount_info.value))
        .reduce((acc, amount) => acc + amount, 0);

      return {
        label: status,
        value: totalAmount,
      };
    });

    return dataForPieChart;
  }

  generatePieChart(data: any[]) {
    // this.ngxService.show()
    const canvas: any = document.getElementById('pieChart');
    const ctx = canvas.getContext('2d');

    new Chart(ctx, {
      type: 'pie',
      data: {
        labels: data.map((item) => item.label),
        datasets: [
          {
            data: data.map((item) => item.value),
            backgroundColor: [
              'rgba(135, 211, 124,1)',
              'rgba(11, 127, 171,1)',
              'rgba(255, 76, 48,1)',
              'rgba(245, 230, 83,1)',
              'rgba(159, 90, 253,1)',
              'rgba(208, 218, 142,1)',
              'rgba(237, 233, 157,1)',
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              generateLabels: (chart: any) => {
                const data = chart.data;
                if (data.labels.length && data.datasets.length) {
                  return data.labels.map((label, index) => {
                    const value = data.datasets[0].data[index];
                    return {
                      text: `${label}: ₹${value}`,
                      fillStyle: data.datasets[0].backgroundColor[index],
                      hidden: false,
                      index: index,
                    };
                  });
                }
                return [];
              },
            },
          },
        },
      },
    });

    // this.ngxService.hide()
  }

  removeBillFromTrip(
    event: MouseEvent,
    billId: string,
    billEtag: string,
  ): void {
    event.stopPropagation();
    const updatedData = {
      bill_id: billId,
    };
    this.ds.removeTripBill(billId, updatedData).subscribe(
      (res) => {
        if (
          res &&
          res._status &&
          String(res._status).toLowerCase() === 'ok' &&
          res._success &&
          res._success.message
        ) {
          this._snackBar.open('Removed Assigned bill.');
          this.loadData();
        } else {
          this._snackBar.open('Removed Assigned bill.');
          this.loadData();
        }
      },
      (error: HttpErrorResponse) => {
        console.debug(error.message);
        this._snackBar.open('Error:::' + error.message);
      }
    );
    console.debug('Removing bill with ID:', billId);
  }

  updateBillStatus(items: any[]): void {
    if (items.length === 0) {
      this.billStatus = 'Add Bills';
      return;
    }

    let anyApprovedOrPaid = false;
    let anyRejected = false;
    let allPaid = true;

    items.forEach((item) => {
      const latestStatus = this.getLatestStatus(item);
      if (latestStatus === 'Rejected') {
        anyRejected = true;
      } else if (latestStatus === 'Approved' || latestStatus === 'Paid') {
        anyApprovedOrPaid = true;
      }
      if (latestStatus !== 'Paid') {
        allPaid = false;
      }
    });

    if (anyRejected) {
      this.billStatus = 'Rejected';
    } else if (allPaid) {
      this.billStatus = 'Paid';
    } else if (anyApprovedOrPaid) {
      this.billStatus = 'Approved';
    } else {
      this.billStatus = 'Pending';
    }
  }

  getImageUrlObservable(file: string): any {
    const apiUrl = environment.apiUrl + file;
    return apiUrl;
  }

  ngOnDestroy(): void {
    // Clean up subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
  isLoggedIn(): boolean {
    console.debug('User', localStorage.getItem('currentUser'));
    return !!localStorage.getItem('currentUser');
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  showReceiptList() {
    this.ds;
  }

  async loadData(): Promise<void> {
    this.ngxService.show()
    try {
      const response = await this.ds.getTripBills(this.tripId).toPromise();
      console.debug(response._items);
      this.dataSource = new MatTableDataSource(response._items);

      this.updateBillStatus(response._items);
      console.debug('this.tripStatus:::', this.billStatus);
      this.headlineService.setHeadline('Trip Status: ' + this.billStatus);

      console.debug('this.dataSource::', this.dataSource.data);
    } catch (error) {
      console.error(error);
    } finally {
      this.ngxService.hide()
    }
  }

  imageLoadedFor(elementId: string) {
    this.imageLoaded[elementId] = true;
  }

  getLatestStatus(element: any): string {
    console.debug('element', element);
    let latestStatus = null;
    let latestDate = null;
    for (const key in element.status) {
      if (element.status.hasOwnProperty(key)) {
        const status = element.status[key];
        if (!latestDate || status.date > latestDate) {
          latestDate = status.date;
          latestStatus = status.value;
        }
      }
    }

    return latestStatus;
  }

  openBillAdd(): void {
    const dialogRef = this.dialog.open(AssignbillComponent, {
      width: '400px',
      height: '250px',
      data: { trip_id: this.tripId, org_id: this.orgId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.loadData();
    });
  }

  getUserIdFromLocal(): string {
    var storedResponse = localStorage.getItem('LoginResponse');
    if (storedResponse !== null) {
      var parsedResponse = JSON.parse(storedResponse);
      var userId = parsedResponse._items[0].user_id;
      console.debug(userId + ' localtorage');
      return userId;
    } else {
      console.error('Stored response is null');
      return '';
    }
  }

  showDetails(row: any) {
    // this.ds.setRecord(row);
    console.debug('hello navigate', row);
    const page='trip'
    this.router.navigate([`/scaned-receipt/${page}/${row._id}`]);
  }

  calculateTotalAmount(status: string): string {
    const totalAmount = this.dataSource.data
      .filter(
        (element) =>
          this.getLatestStatus(element) === status &&
          !isNaN(Number(element.amount_info.value))
      )
      .map((element) => Number(element.amount_info.value))
      .reduce((acc, amount) => acc + amount, 0);

    return `₹${totalAmount.toFixed(2)}`;
  }
  openExportFormatDialog(): void {
    const dialogRef = this.dialog.open(ExportComponentComponent, {
      width: '400px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: 'csv' | 'xlsx' | 'pdf') => {
      if (result) {
        this.exportData(result);
      }
    });
  }

  exportData(format: 'csv' | 'xlsx' | 'pdf') {
    const transformedData = this.transformData(this.dataSource.data);
    if (format === 'csv') {
      this.exportService.exportToCsv(
        'export',
        transformedData,
        this.headers,
        this.title
      );
    } else if (format === 'xlsx') {
      this.exportService.exportToXlsx(
        'export',
        transformedData,
        this.headers,
        this.title
      );
    } else if (format === 'pdf') {
     const data= transformedData.map(row => [ 
        row.Bill_Name,
        row.Created_By,
        row.Trip_Name,
        row.Category,
        row.Date_on_bill,
        row.Time_on_bill,
        row.Amount,
        row.Organization,
        row.Status,
        row.Phone,
      ]);
      this.exportService.exportToPdf(
        'export',
        transformedData,
        this.headers,
        this.title,data
      );
    }
  }

  private formatDate(date: string): string {
    return this.datePipe.transform(new Date(date), 'yyyy-MM-dd') || 'N/A';
  }
  transformData(data: any[]): any[] {
    return data.map((item) => ({
      Bill_Name: item.name,
      Created_By: item.user_id.name,
      Trip_Name: item?.trip_id?.trip_name,
      Category: item?.category_id?.name,
      Date_on_bill: this.formatDate(item?.date_info.value),
      Time_on_bill: item.time_info.value,
      Amount: item?.amount_info.value,
      Organization: item.organization_id.name,
      Status: this.getLatestStatus(item),
      Phone: item.phone_info.value,
    }));
  }
}
